import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { ProductStoryTellingVideoTileModel } from '@/types/B2CcontentServerContract';
import { computed } from 'vue';
import MediaHandler from '@/shared/content/blocks/helpers/MediaHandler.vue';
import { MediaModel } from '@/types/B2BcontentServerContract';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductStoryTellingVideoTile',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as { content: ProductStoryTellingVideoTileModel }


const mediaBlock = computed<MediaModel>(() => props.content.media);
const aspectRatio = 16 / 9;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    (_unref(mediaBlock))
      ? (_openBlock(), _createBlock(MediaHandler, {
          key: 0,
          "media-block": _unref(mediaBlock),
          "media-aspect-ratio": aspectRatio
        }, null, 8, ["media-block"]))
      : _createCommentVNode("", true)
  ]))
}
}

})